import { CircleSkeleton, Skeleton } from '@/components/Skeleton';

export const InteractLogLoadingSkeleton = () => {
  return (
    <div className="border-t border-secondary">
      <div className="mt-[50px] flex flex-col gap-2 overflow-y-auto">
        {Array.from({ length: 10 }).map(() => (
          <div className="flex flex-col gap-2 px-6 py-1.5">
            <div className="flex items-center gap-2">
              <CircleSkeleton />
              <Skeleton className="h-6" />
            </div>
            <Skeleton className="h-[100px]" />
          </div>
        ))}
      </div>
    </div>
  );
};
